export default "__VITE_ASSET__DCfOpbM1__"